<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    class="deliverySiteAddressDialog onDialogBox"
  >
    <div class="formBox">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="auto"
        :key="formKey"
      >
        <el-form-item :label="$fanyi('收件人') + '：'" prop="contacts">
          <el-input
            size="mini"
            class="uiInput"
            v-model="form.contacts"
            oninput="this.value"
          />
        </el-form-item>
        <el-form-item :label="$fanyi('邮编') + '：'" prop="zip_code">
          <el-input
            size="mini"
            class="uiInput"
            v-model="form.zip_code"
            oninput="this.value"
          />
        </el-form-item>
        <el-form-item :label="$fanyi('城市') + '：'" prop="city">
          <el-input
            type="textarea"
            class="uiInput"
            v-model="form.city"
            show-word-limit
            resize="none"
            :autosize="{ minRows: 1, maxRows: 12 }"
            oninput="this.value"
          />
        </el-form-item>
        <el-form-item :label="$fanyi('省份') + '：'" prop="province">
          <el-input
            type="textarea"
            class="uiInput"
            v-model="form.province"
            show-word-limit
            resize="none"
            :autosize="{ minRows: 1, maxRows: 12 }"
            oninput="this.value"
          />
        </el-form-item>
        <el-form-item :label="$fanyi('国家') + '：'" prop="country">
          <el-input
            type="textarea"
            class="uiInput"
            v-model="form.country"
            show-word-limit
            resize="none"
            :autosize="{ minRows: 1, maxRows: 12 }"
            oninput="this.value"
          />
        </el-form-item>
        <el-form-item :label="$fanyi('地址') + '：'" prop="address">
          <el-input
            type="textarea"
            class="uiInput"
            v-model="form.address"
            show-word-limit
            resize="none"
            :autosize="{ minRows: 1, maxRows: 12 }"
            oninput="this.value"
          />
        </el-form-item>
        <el-form-item :label="$fanyi('电话') + '：'" prop="mobile">
          <el-input
            size="mini"
            class="uiInput"
            v-model="form.mobile"
            oninput="this.value"
          />
        </el-form-item>
        <el-form-item :label="$fanyi('邮件箱') + '：'" prop="email">
          <el-input
            size="mini"
            class="uiInput"
            v-model="form.email"
            oninput="this.value"
          />
        </el-form-item>
        <el-form-item :label="$fanyi('是否默认') + '：'">
          <el-switch v-model="form.isAcquiescent" class="uiSwitch" />
        </el-form-item>
      </el-form>
      <div class="btn">
        <p v-if="isAdd">
          <el-button
            class="uiBtn uiGreen"
            type="button"
            @click="useraddressAdd"
          >
            {{ $fanyi("新增") }}
          </el-button>
          <el-button class="uiBtn uiFontGreen" type="button" @click="openAdd">
            {{ $fanyi("重置") }}
          </el-button>
        </p>
        <p class="edit" v-else>
          <el-button
            class="uiBtn uiMintBlue"
            type="button"
            @click="useraddressDelete"
          >
            {{ $fanyi("删除") }}
          </el-button>
          <el-button
            class="uiBtn uiGreen"
            type="button"
            @click="useraddressUpdate"
          >
            {{ $fanyi("保存") }}
          </el-button>
        </p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "DeliverySiteAddressDialog",
  props: {
    addressType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      dialogVisible: false,
      title: "",
      isAdd: false,
      formKey: "delivery-address",
      form: {},
      rules: {
        zip_code: [
          { required: true, message: this.$fanyi("不能为空"), trigger: "blur" },
        ],
        address: [
          { required: true, message: this.$fanyi("不能为空"), trigger: "blur" },
        ],
        contacts: [
          { required: true, message: this.$fanyi("不能为空"), trigger: "blur" },
        ],
        mobile: [
          { required: true, message: this.$fanyi("不能为空"), trigger: "blur" },
        ],
        city: [
          { required: true, message: this.$fanyi("不能为空"), trigger: "blur" },
        ],
        province: [
          { required: true, message: this.$fanyi("不能为空"), trigger: "blur" },
        ],
        country: [
          { required: true, message: this.$fanyi("不能为空"), trigger: "blur" },
        ],
        email: [
          { required: true, message: this.$fanyi("不能为空"), trigger: "blur" },
          {
            type: "email",
            message: this.$fanyi("请输入正确的邮箱地址"),
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    emptyForm() {
      return {
        type: this.addressType,
        company: "",
        zip_code: "",
        address: "",
        city: "",
        province: "",
        country: "",
        contacts: "",
        mobile: "",
        tel: "",
        email: "",
        cnpj: "",
        mark: "",
        acquiescent: 0,
        isAcquiescent: false,
      };
    },
    openAdd() {
      this.dialogVisible = true;
      this.formKey = Math.random()
        .toString(36)
        .slice(-8);
      this.form = this.emptyForm();
      this.isAdd = true;
      this.title = this.$fanyi("新增地址");
    },
    openEdit(item) {
      const copy = JSON.parse(JSON.stringify(item));
      copy.isAcquiescent =
        Number(copy.acquiescent) === 1 || copy.acquiescent === true;
      this.form = copy;
      this.title = this.$fanyi("编辑地址");
      this.isAdd = false;
      this.dialogVisible = true;
      this.formKey = Math.random()
        .toString(36)
        .slice(-8);
    },
    handleClose(done) {
      // 退出确认：按钮文案走 $fanyi，意大利语取消为 Annulla
      this.$confirm(this.$fanyi("信息未保存，确认退出吗？"), "", {
        confirmButtonText: this.$fanyi("确认"),
        cancelButtonText: this.$fanyi("取消"),
      })
        .then(() => {
          this.form = this.emptyForm();
          done();
        })
        .catch(() => {});
    },
    syncAcquiescentToForm() {
      this.form.isAcquiescent
        ? (this.form.acquiescent = 1)
        : (this.form.acquiescent = 0);
    },
    stripEmptyFieldsForSubmit() {
      const data = JSON.parse(JSON.stringify(this.form));
      for (const i in data) {
        if (!data[i]) {
          delete data[i];
        }
      }
      return data;
    },
    useraddressAdd() {
      this.syncAcquiescentToForm();
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const payload = this.stripEmptyFieldsForSubmit();
        this.$api.useraddressAdd(payload).then((res) => {
          if (res.code != 0)
            return this.$message.error(this.$fun.apiErrorMsg(res.msg));
          this.$message.success(this.$fanyi("保存成功"));
          this.dialogVisible = false;
          this.$emit("success");
        });
      });
    },
    useraddressUpdate() {
      this.syncAcquiescentToForm();
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.$api.useraddressUpdate(this.form).then((res) => {
          if (res.code != 0)
            return this.$message.error(this.$fun.apiErrorMsg(res.msg));
          this.$message.success(this.$fanyi("保存成功"));
          this.dialogVisible = false;
          this.$emit("success");
        });
      });
    },
    useraddressDelete() {
      let msg = this.$fanyi("是否删除当前地址");
      if (this.form.isAcquiescent == 1 || this.form.isAcquiescent === true) {
        msg = this.$fanyi("不保存更改就退出?");
      }
      this.$confirm(msg, this.$fanyi("提示"), {
        confirmButtonText: this.$fanyi("确认"),
        cancelButtonText: this.$fanyi("取消"),
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$api.useraddressDelete({ id: this.form.id }).then((res) => {
            if (res.code != 0)
            return this.$message.error(this.$fun.apiErrorMsg(res.msg));
            this.$message.success(this.$fanyi("保存成功"));
            this.dialogVisible = false;
            this.$emit("success");
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$fanyi("删除取消"),
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../../css/mixin";

.uiInput.el-input {
  min-height: 40px;
  /deep/ .el-input__inner {
    height: 40px;
    font-size: 14px;
    border-radius: 8px;
    color: #000000;
  }
}

.uiInput.el-textarea {
  min-height: 56px;
  /deep/ .el-textarea__inner {
    min-height: 56px !important;
    font-size: 14px;
    border-radius: 8px;
    color: #000000;
    line-height: 20px;
  }
}

.btn {
  text-align: center;
  .uiBtn {
    border-radius: 12px;
    font-size: 16px;
    line-height: 20px;
    min-width: 120px;
    height: 46px;
  }
  .uiBtn + .uiBtn {
    margin-left: 20px;
  }
}

.formBox {
  padding: 40px;
}
</style>
